import { TestSuiteForm } from '@/components/forms/TestSuiteForm';
import { PageContainer } from '@/components/PageContainer';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/test-suites/add')({
  component: RouteComponent,
  beforeLoad: () => {
    return {
      pageTitle: 'Add Test Suite',
    };
  },
});

function RouteComponent() {
  return (
    <PageContainer>
      <TestSuiteForm />
    </PageContainer>
  );
}
